import { ParameterGroup, ParametersApi, ParameterType } from 'oas';
import { UseQueryResult } from 'react-query';
import { useApiQuery } from '../use-api-query';
import { TfReportingParameterGroup, transformParameterGroups } from './transform';
import { useDependantApiQuery } from '../use-dependant-api-query';

export const useGetParameterGroups = (): UseQueryResult<ParameterGroup[]> => {
    return useApiQuery(['parameter_groups'], (apiConfig, axiosInstance) =>
        new ParametersApi(apiConfig, '', axiosInstance).getParameterGroups(),
    );
};

export const useGetReportingParameters = (): UseQueryResult<TfReportingParameterGroup[]> => {
    const types = useGetAllParameterTypes();
    return useDependantApiQuery(
        ['reporting_parameter_groups'],
        (apiConfig, axiosInstance) =>
            new ParametersApi(apiConfig, '', axiosInstance)
                .getParameterGroups()
                .then((response) => ({ ...response, data: transformParameterGroups(response.data, types.data ?? []) })),
        !!types.data,
    );
};

export const useGetAllParameterTypes = (): UseQueryResult<ParameterType[]> => {
    return useApiQuery(['parameter_types'], (apiConfig, axiosInstance) =>
        new ParametersApi(apiConfig, '', axiosInstance).getAllParameterTypes(),
    );
};
